// extracted by mini-css-extract-plugin
module.exports = {"logoutModal":"Sidebar_logoutModal__347UC"};